import { render, staticRenderFns } from "./giftbagItem.vue?vue&type=template&id=31f419f6&scoped=true&"
import script from "./giftbagItem.vue?vue&type=script&lang=js&"
export * from "./giftbagItem.vue?vue&type=script&lang=js&"
import style0 from "./giftbagItem.vue?vue&type=style&index=0&id=31f419f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f419f6",
  null
  
)

export default component.exports